module.exports = __webpack_public_path__ + "img/ai.54682023.svg";